// extracted by mini-css-extract-plugin
export default {"regulationContainer":"Regulation_regulationContainer__Ji-lU","regulationText":"Regulation_regulationText__WqcSe"};